import { rem } from '../../libs/polished';
import type { Spacing } from '../types';

const basePx: Spacing = {
  '-4x': '-8px',
  '-2x': '-4px',
  none: '0px',
  '1x': '2px',
  '2x': '4px',
  '3x': '6px',
  '4x': '8px',
  '5x': '10px',
  '6x': '12px',
  '8x': '16px',
  '10x': '20px',
  '12x': '24px',
  '16x': '32px',
  '20x': '40px',
  '22x': '44px',
  '24x': '48px',
  '32x': '64px',
  '52x': '104px',
};

/**
 * @deprecated please use values from ThemeProvider
 */
const spacing = Object.entries(basePx).reduce((acc, [key, pxVal]) => {
  acc[key as keyof Spacing] = rem(pxVal);

  return acc;
}, {} as Spacing);

export default spacing;
